// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__MG6n5","tagButton":"styles_tagButton__aiKtm","icon":"styles_icon__oOQST","label":"styles_label__a1ZuT"};